import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { generalGet } from "../api/general";

export const useGetQuery = <T>(url: string, skip: boolean = false) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<AxiosError | null>(null);
  const [loading, setLoading] = useState(false);

  const getData = async (): Promise<void> => {
    setLoading(true);
    try {
      const resp = await generalGet<T>(url);
      setData(resp.data);
      setError(null);
    } catch (ex) {
      setError(ex as AxiosError);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!skip) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, skip]);

  return { data, error, loading, setData };
};
